import type { TileStatusContext } from '~/viewportGrid';
import TileImageMarksOfImage from './TileImageMarksOfImage';

// Marks each drawn image with its role in a comparison and whether it was resampled rather than acquired.
export default function TileImageMarks({
    images,
}: Pick<TileStatusContext, 'images'>) {
    return (
        <>
            {images.map((image) => (
                <TileImageMarksOfImage
                    key={image.seriesInstanceUid}
                    image={image}
                />
            ))}
        </>
    );
}
